import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Estado } from '../interfaces/estado';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class EstadoService {

  readonly path = '/estado';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  saveOrUpdate(cadastro: Estado): Observable<Estado> {
    return this.http.put<Estado>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }

  getEstado(id: number ): Observable<Estado> {
    return this.http.get<Estado>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getEstadoPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<Estado>> {
    return this.http.get<PageResult<Estado>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getEstadoPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<Estado>> {
    return this.http.get<PageResult<Estado>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }
}
